// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Independence80_wrap__gCm51","heroTransparent":"Independence80_heroTransparent__aYZ58"};